import {useSyncExternalStore} from 'react';

const subscribe = () => () => undefined;

/**
 * `false` on the server and while the component hydrates, `true` afterwards (and on client renders).
 *
 * Unlike `useUI('isServer')` (Redux, flipped once by the first page), the value a component hydrates with
 * always matches the server HTML, even when its Suspense boundary hydrates after the flip.
 *
 * @returns {boolean} - Whether client-only content can be rendered
 */
const useHydrated = (): boolean => useSyncExternalStore(subscribe, () => true, () => false);

export default useHydrated;
